import {useCallback, useState} from "react";

export const useNodeRef = (): [HTMLElement | null, any] => {
    const [node, setNode] = useState<HTMLElement | null>(null);
    const ref = useCallback((node: HTMLElement) => {
        if (node !== null) {setNode(node);}
    }, []);

    return [node, ref];
}